// extracted by mini-css-extract-plugin
module.exports =  {"header":"DU5RFP0","title":"YYRvphJ","floating":"bMLOqUU","title-container":"bxuYJ4Q","titleContainer":"bxuYJ4Q","text-align-center":"qAKw1wW","textAlignCenter":"qAKw1wW"};